module.exports = __webpack_public_path__ + "static/images/c3df8526459082a9a31424a84c0d3645.png";